// App.tsx
import React, { useEffect, useState } from "react";
import AppRouter from "./routes/AppRouter.tsx";
import CustomSpinner from "./components/core/spinner/CustomSpinner.tsx";
import AuthService from "./services/AuthService.ts";

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  

  useEffect(() => {
    setIsLoading(true);
    const authService = AuthService.getInstance();

    async function isAuthenticated(){
      try { 
        await authService.loadAppConfig();
        await authService.loadAzureConfig();
        await authService.initializeMsalClient();
        setIsLoading(false);
      } catch (Exception){
        console.error(Exception);
        setIsLoading(false);
      }
    }
    isAuthenticated()
  }, []);


  if(isLoading){
    return <CustomSpinner />;
  }

  return (
    <div className="app">
      <AppRouter />
    </div>
  );
};

export default App;
